import {action, makeAutoObservable, makeObservable, observable} from "mobx";
import {isLocalStorageAvailable, parseJwt} from "../utilites";
import {Howler} from 'howler';
import {getOtherGames} from "../api";
import {pixiComponents} from "../index";

class Store {
    gameId = 14;
    accessToken = null;
    partnerId = null;
    lobbyEnabled = false;
    sessionDurationSeconds = 500;
    currency = "FUN";
    parsedJwt = null;
    isSoundOff = isLocalStorageAvailable() ? localStorage.getItem('isSoundOff') === 'true': false;
    lastWinAmount = null;
    isHorizontalScreen = null;
    isSessionExpired = false;
    translations = {};
    languageCode = null;
    offeredOtherGames = [];
    rtp = 96;
    maxBet = 0;
    maxOdd = 0;
    maxWin = 0;
    minBet = 0;

    constructor() {
        makeAutoObservable(this);
        this.setPartnerIdByUrl()
        this.setLanguageCodeByUrl();
        this.setOfferedOtherGames();
    }

    setMinBet(value) {
        this.minBet = value;
    }

    setMaxBet(value) {
        this.maxBet = value;
    }

    setMaxWin(value) {
        this.maxWin = value;
    }

    setMaxOdd(value) {
        this.maxOdd = value;
    }

    setOfferedOtherGames = async () => {
        const offeredOtherGames = await getOtherGames(this.gameId);
        this.offeredOtherGames = offeredOtherGames.data;
    }

    setLanguageCodeByUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        this.languageCode = urlParams.get('languageCode');
    }

    setTranslations(translations) {
        this.translations = translations;
    }

    setIsSessionExpired(bool) {
        this.isSessionExpired = bool;
    }

    setLastWinAmount(amount) {
        this.lastWinAmount = amount;
    }

    setIsHorizontalScreen(bool) {
        this.isHorizontalScreen = bool;
    }

    setPartnerId(id) {
        this.partnerId = id;
    }

    setLobbyEnabled(bool) {
        this.lobbyEnabled = bool;
        pixiComponents.cpItems.otherGamesSection.updateComponentsMetrics();
    }

    soundToggle() {
        this.isSoundOff = !this.isSoundOff;
        isLocalStorageAvailable() && localStorage.setItem('isSoundOff', this.isSoundOff.toString());
        Howler.mute(this.isSoundOff);
    }

    setSessionDurationSeconds(duration) {
        this.sessionDurationSeconds = duration;
    }

    setPartnerIdByUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const partnerId = urlParams.get('partnerId');
        this.setPartnerId(partnerId * 1);
    }

    isDemo() {
        const urlParams = new URLSearchParams(window.location.search);
        const mode = urlParams.get('mode');
        return mode === "fun";
    }

    setAccessToken(token) {
        this.accessToken = token;
        this.parsedJwt = parseJwt(token);
        this.currency = this.isDemo() ? "FUN" : this.parsedJwt.currency;
    }

}

export const store = new Store();
